export default __webpack_public_path__ + "static/media/stan.558d183d.png";